import { render, staticRenderFns } from "./CarouselScheme.vue?vue&type=template&id=6e14e15b&scoped=true"
import script from "./CarouselScheme.vue?vue&type=script&lang=js"
export * from "./CarouselScheme.vue?vue&type=script&lang=js"
import style0 from "./CarouselScheme.vue?vue&type=style&index=0&id=6e14e15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e14e15b",
  null
  
)

export default component.exports